import { combineReducers } from 'redux';
import certificate from './Certificate';
import license from './License';
import password from './Password';

export default combineReducers({
  certificateState: certificate,
  licenseState: license,
  passwordState: password
});
